import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { motion } from "framer-motion";

const links = [
  { to: "/", label: "ΑΡΧΙΚΗ", testid: NAV.linkHome, hash: "" },
  { to: "/#gallery", label: "ΣΥΛΛΟΓΗ", testid: NAV.linkGallery, hash: "gallery" },
  { to: "/#manifesto", label: "MANIFESTO", testid: NAV.linkManifesto, hash: "manifesto" },
  { to: "/epikoinonia", label: "ΕΠΙΚΟΙΝΩΝΙΑ", testid: NAV.linkContact, hash: "" },
];

export default function Nav() {
  const loc = useLocation();

  const handleAnchor = (e, hash) => {
    if (!hash) return;
    if (loc.pathname === "/") {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.9, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-[var(--bg)] border-b border-[var(--ink)]"
    >
      <div className="px-4 md:px-8 lg:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid={NAV.logo}
          aria-label="BLOUZES4ALL — Αρχική"
          className="font-display text-xl md:text-2xl leading-none flex items-center gap-2"
        >
          BLOUZES<span className="text-[var(--lime)] bg-[var(--ink)] px-1">4</span>ALL
        </Link>
        <nav aria-label="Κύρια πλοήγηση" className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              onClick={(e) => handleAnchor(e, l.hash)}
              data-testid={l.testid}
              className="font-mono-caps text-xs hover:text-[var(--pink)] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3 font-mono-caps text-[10px]">
          <span className="w-2 h-2 rounded-full bg-[var(--lime)] animate-pulse" />
          ATHENS — GR
        </div>
        {/* Mobile nav links row */}
        <nav aria-label="Πλοήγηση κινητού" className="md:hidden flex items-center gap-3">
          {links.slice(1).map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              onClick={(e) => handleAnchor(e, l.hash)}
              data-testid={l.testid + "-m"}
              className="font-mono-caps text-[10px]"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </motion.header>
  );
}
